import React from "react";

// Define types for the props
export interface Team {
  name: string;
}

interface TeamsProps {
  teams: [Team, Team];
}

const EventTeams: React.FC<TeamsProps> = ({ teams }) => {
  const [team1, team2] = teams;

  return (
    <React.Fragment>
      <div className="asian-event__runner-name">
        <span>{team1.name}</span>
      </div>
      <div className="asian-event__runner-name">
        <span>{team2.name}</span>
      </div>
    </React.Fragment>
  );
};

export default EventTeams;
